import { render, staticRenderFns } from "./AgentTipFrame.vue?vue&type=template&id=fdbf903e&scoped=true&"
import script from "./AgentTipFrame.vue?vue&type=script&lang=js&"
export * from "./AgentTipFrame.vue?vue&type=script&lang=js&"
import style0 from "./AgentTipFrame.vue?vue&type=style&index=0&id=fdbf903e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbf903e",
  null
  
)

export default component.exports